///ts:ref=pixi.js
/// No file or directory matched name "pixi.js" ///ts:ref:generated

/**
 * overrides GLTexture upload, adds SuperAtlas as source
 * @param source
 * @returns {any}
 */

declare module PIXI.glCore {
	interface VertexArrayObject {
		/**
		 * either number of atlas elements uploaded
		 * either version of dynamic canvas texture
		 */
		hackAttribStart(index: number, start: number): void
	}
}

namespace PIXI.glCore {
	(Object as any).assign(VertexArrayObject.prototype, {
		hackAttribStart: function(index:number, start: number) {
			const attrib = this.attributes[index];
			const gl = this.gl;
			gl.vertexAttribPointer(attrib.attribute.location,
				attrib.attribute.size,
				attrib.type || gl.FLOAT,
				attrib.normalized || false,
				attrib.stride || 0,
				start);
		}
	});
}
